module.exports = __webpack_public_path__ + "img/mobile-creative-title-03.8ab50127.svg";